import { BaseHeading } from "./BaseHeading.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/headings/Heading1.tsx
const Heading1 = ({ children, color = "gray", size = "h1", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(BaseHeading, {
	order: 1,
	size,
	color,
	ta,
	"data-testid": testId,
	children
});

//#endregion
export { Heading1 };